<div class="no-data">
  <div class="text">{{ text ? text : 'No Data' }}</div>
  @if (showRequired) {
    <div class="subtext error">
      <mat-icon>warning</mat-icon>
      Required Field
    </div>
  }
</div>
